import { DEFAULT_ADSENSE_CONFIG, type AdsenseConfig } from './adsense-config';

/** Same OAuth client as legacy `pro-frontend/static/login/` (GIS sign-in). */
export const DEFAULT_GOOGLE_CLIENT_ID =
  '338494118505-qr1ed5qbuqh8cr597qeuhb8pbc6lemvp.apps.googleusercontent.com';

export interface AppConfig {
  production: boolean;
  /** Live-only GA/Ads/FB/Bing/Clarity; requires live hostname too. */
  enableMarketingTags: boolean;
  apiBaseUrl: string;
  webDomain: string;
  googleClientId: string;
  jobsPageUrl: string;
  careerCoachingPageUrl: string;
  proExamplesUrl: string;
  gcsStorageUrl: string;
  allowAiModelSelection: boolean;
  posthogKey: string;
  pusherKey: string;
  razorPayKey: string;
  paddleToken: string;
  dodoCheckoutMode: 'test' | 'live';
  whatsappVerificationGeoGate: boolean;
  /** When false, upgrade A/B experiments always resolve to control. */
  upgradeExperimentsEnabled: boolean;
  /** Comma-separated flag allowlist; empty means all registered flags. */
  upgradeExperimentFlags: string;
  adsense: AdsenseConfig;
}

export const DEFAULT_APP_CONFIG: AppConfig = {
  production: true,
  enableMarketingTags: false,
  apiBaseUrl: 'https://api.kudoswall.com',
  webDomain: 'https://kudoswall.com',
  googleClientId: DEFAULT_GOOGLE_CLIENT_ID,
  jobsPageUrl: 'https://jobs.kudoswall.com',
  careerCoachingPageUrl: 'https://bootcamp.kudoswall.com',
  proExamplesUrl: 'https://examples.kudoswall.com',
  gcsStorageUrl: 'https://storage.googleapis.com/prod_kw_storage',
  allowAiModelSelection: false,
  posthogKey: '',
  pusherKey: '',
  razorPayKey: '',
  paddleToken: '',
  dodoCheckoutMode: 'test',
  whatsappVerificationGeoGate: true,
  upgradeExperimentsEnabled: false,
  upgradeExperimentFlags: '',
  adsense: DEFAULT_ADSENSE_CONFIG,
};

export function mergeRuntimeConfig(overrides: Partial<AppConfig>): AppConfig {
  return {
    ...DEFAULT_APP_CONFIG,
    ...overrides,
  };
}

export function toPublicRuntimeConfig(config: AppConfig): AppConfig {
  return {
    production: config.production,
    enableMarketingTags: config.enableMarketingTags,
    apiBaseUrl: config.apiBaseUrl,
    webDomain: config.webDomain,
    googleClientId: config.googleClientId,
    jobsPageUrl: config.jobsPageUrl,
    careerCoachingPageUrl: config.careerCoachingPageUrl,
    proExamplesUrl: config.proExamplesUrl,
    gcsStorageUrl: config.gcsStorageUrl,
    allowAiModelSelection: config.allowAiModelSelection,
    posthogKey: config.posthogKey,
    pusherKey: config.pusherKey,
    razorPayKey: config.razorPayKey,
    paddleToken: config.paddleToken,
    dodoCheckoutMode: config.dodoCheckoutMode,
    whatsappVerificationGeoGate: config.whatsappVerificationGeoGate,
    upgradeExperimentsEnabled: config.upgradeExperimentsEnabled,
    upgradeExperimentFlags: config.upgradeExperimentFlags,
    adsense: config.adsense,
  };
}
